<template>
    <div class="row classical-result-container-wrapper">
        <div class="col-6 my-3">
            <div class="inner-box p-0 classical-result-row-wrapper">
                <div class="row h-100">
                    <div class="col-7 p-4 d-flex align-items-center">
                        <div class="result-title pl-2">
                            Your Roman index is
                            <span :style="{ color: getClassicalColour('roman') }">
                                {{ result?.romans?.index?.toFixed(2) }}</span>
                        </div>
                    </div>
                    <div class="col-5 d-flex align-items-center px-0 pb-3 pb-md-0">
                        <div class="max-w-180">
                            <DoughnutChart v-if="result?.romans?.index" :chart-data="chartData" :options="options"
                                :ChartColor="getClassicalColour('roman')" :centerTitle="''" chartWidth="100%"
                                chartHeight="100%" />
                        </div>

                        <!-- <img src="../../../../assets/images/ancetry/donut.png" alt="Logo" /> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6 my-3">
            <div class="inner-box classical-result-row-wrapper">
                <div class="row w-100 align-items-center d-flex">
                    <div class="col-6">
                        <h5 class="text-start">
                            <b>To view a your Roman Index Map and more Information</b>
                        </h5>
                        <div class="d-flex justify-content-start">
                            <a href="#" class="my-2 d-block load-btn-result" @click="action">Click Here</a>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="banner-box">
                            <img src="../../../../assets/images/ancetry/map-4.png" alt="Logo" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="inner-box p-4 mb-4">
                <h4><b>Percentile </b></h4>
                <div class="result-percentile align-items-center">
                    <p>
                        Your percentile is derived from comparing your Roman result to that of other
                        users on our platform. It essentially reflects the percentage of users whose
                        index score is lower than yours.
                    </p>
                    <p>
                        You are in the {{ result?.romans?.percentile }}'th percentile, which means your index score is higher than
                        {{ result?.romans?.percentile }}% of the users in our system. This allows you to gauge your position
                        relative to the broader Living DNA user base.
                    </p>
                </div>
                <div class="d-flex align-items-center justify-content-center mt-3">
                    <div class="">
                        <div class="d-flex">
                            <span class="result-barchart-title">Roman - </span><span class="result-barchart-percent">{{
                                result?.romans?.percentile }}</span>
                        </div>
                        <BarChart class="flex-shrink-0" :percentile="result?.romans?.percentile" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="inner-box mt-3">
                <div class="inner-content">
                    <h4 class="mb-4"><b>{{ understanding.heading }}</b></h4>
                    <div v-html="understanding.text"></div>
                    <!-- <h6 class="mb-3"><b>Classical Index</b></h6>
                    <p>
                        The Classical Index represents the amount of DNA that you share with each
                        major group of peoples from the Classical era; Greek, Roman & Egyptian.
                        First, the genetic similarities between your DNA and the DNA obtained from
                        classical and non-classical samples are computed. This allows us to estimate
                        how close your DNA is to each group. The distance value is converted into
                        the Classical Index, which typically ranges from 1 to 100, and shows your
                        similarity to each of the three Classical groups.
                    </p>
                    <p>
                        In order to better interpret and contextualise the index we compare your
                        values to those of all other Living DNA users. This yields your percentile
                        score for each of the population groups, which allows you to see where your
                        result falls in comparison to the whole range of Classical Indexes across
                        the Living DNA user base. For example, if your Roman Classical Index is 80,
                        this means that your DNA is more similar to Roman DNA than 80% of all Living
                        DNA users
                    </p>
                    <h6 class="mb-3"><b>The Classical Population Match</b></h6>
                    <p>
                        You will have a population match for each major classical group; Greek,
                        Roman & Egyptian.We have identified 13 distinct Classical populations from
                        our analysis of Classical DNA samples; 8 for Roman, 5 for Greek, and 1 for
                        Egyptian. We compare your DNA data to genetic models describing the genetic
                        similarity and variability of these populations in order to identify your
                        closest population. These populations are:
                    </p>
                    <div class="row w-100 roman-container-classical">
                        <div class="col-4 p-4">
                            <h6 class="d-flex">Roman</h6>
                            <p>
                                Levant-Caucasus,North Africa, Iberia, Italy, England, Northern
                                Europe, Eastern Adriatic
                            </p>
                        </div>
                        <div class="col-4 p-4">
                            <h6 class="d-flex">Greek</h6>
                            <p>Caucasus, Iberia, Greece, Macedonia, Turkey-Levant</p>
                        </div>
                        <div class="col-4 p-4">
                            <h6 class="d-flex">Egyptian</h6>
                            <p>Egyptian</p>
                        </div>
                    </div>
                    <h6 class="mb-3"><b>Classical DNA Samples</b></h6>
                    <p>
                        A total of 282 samples dating from the Classical era were used for our
                        analysis. Human remains were excavated in a diverse set of 83 archaeological
                        sites across Europe, North Africa, the Near East and West Asia and have been
                        dated between 1,300 BCE and late 600 CE.
                    </p>
                    <p>
                        Ancient human remains (mostly teeth or petrous bones) were processed and DNA
                        was extracted and sequenced in order to be used to generate our Classical
                        Index and Classical Population Match results. The Classical genetic data was
                        retrieved from 13 scientific publications: Martiniano et al., 2015;
                        Martiniano et al., 2016; Scheunemann et al., 2017; Olalde et al., 2019;
                        Antonio et al., 2019; Haber et al., 2019; Haber et al., 2020; Marcus et al.,
                        2020; Patterson et al., 2021; De Angelis et al., 2022; Moots et al., 2022;
                        Antonio et al., 2022; Lazaridis I. et al., 2022.
                    </p> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, defineProps, computed } from "vue";
import DoughnutChart from "@/components/charts/Doughnut.vue";
// import { getRequiredContent } from "@/composables/useClassicalContent";
import { getClassicalColour, getRequiredContent } from "@/composables/useClassicalContent";
// import { useLoading } from "@/composables/useLoading";
// import ArchaicResultsPercentile from "@/views/archaic/ArchaicResultsPercentile.vue";
import BarChart from "@/components/charts/BarChart.vue";
import store from "@/store/index";
import { defineEmits } from "vue";

defineProps({
    vikingResult: Object,
});
const emit = defineEmits(["action"]);
const action = () => {
    emit("action");
};
// const { loadingStatus, finishLoading } = useLoading();
const understanding = ref({});
const result = store.getters.result;

getRequiredContent(["understanding-your-results"])
    .then(([understandingResult]) => {
        understanding.value = understandingResult;
    })
    .then();

const options = {
    cutout: "70%",
    radius: "100%",
    responsive: true,
    maintainAspectRatio: true,
};

const chartData = computed(() => ({
    cutoutPercentage: 10,
    datasets: [
        {
            data:
                result?.romans?.index <= 100
                    ? [result?.romans?.index, 100 - result?.romans?.index]
                    : [100, 0],
            backgroundColor: [getClassicalColour("roman"), "#ddd"],
        },
    ],
    labels: [],
}));
</script>
